import { useDecisionMakerResponsePageData } from '#src/app/pages/decisionMaker/response/details/pageContext';

type Result = ModelHookResult<{
	description: string;
	creationDate: string;
	embeddedMedia?: { html: string | null; aspectRatio: number | null };
}>;

export function usePageBody(): Result {
	const {
		data: {
			decisionMakerResponse: { message, createdAtLocalized, embeddedMedia },
		},
	} = useDecisionMakerResponsePageData();

	return {
		data: {
			description: message,
			creationDate: createdAtLocalized,
			embeddedMedia: embeddedMedia || undefined,
		},
	};
}
